<template>
  <div class="dui-option-search">
    <DuiSearchInput
      v-if="!selectedOption"
      ref="searchText"
      v-model="searchText"
      :placeholder="placeholder"
      :disabled="disabled"
      @input="searchTextUpdated"
    />

    <div
      v-if="selectedOption"
      class="selected-option"
    >
      <span
        class="label-sm"
        :class="('label-' + labelColor)"
      >
        <img
          v-if="selectedOption.imageUrl"
          class="image-circle border-white"
          :src="selectedOption.imageUrl"
        >

        <span class="valign-middle">{{ selectedOption.text }}</span>

        <a
          v-if="!disabled"
          class="button-grey button-icon button-sm button-close space-left-1em"
          title="Remove"
          @click="clearSelectedOption"
        />
      </span>
    </div>

    <div
      class="options-container"
      :class="{ 'searching': isSearching,
                'show-options': showOptions }"
    >
      <DuiLoadingIndicator
        v-if="isSearching"
        size="lg"
      />

      <div
        v-if="(!isSearching && !availableOptions.length)"
        class="no-results"
      >
        No results.
      </div>

      <div v-if="!isSearching && availableOptions.length">
        <span
          v-for="(option, index) in availableOptions"
          :key="index"
          class="option"
          :title="option.text"
          @click="selectOption(option)"
        >
          <img
            v-if="option.imageUrl"
            class="image-circle border-white"
            :src="option.imageUrl"
          >
          <span class="valign-middle">{{ option.text }}</span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isSearching: {
      type: Boolean,
      default: false,
    },
    labelColor: {
      type: String,
      default: 'grey',
    },
    maxResults: {
      type: Number,
      default: 8,
    },
    options: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: 'Search here...',
    },
    value: {
      type: Object,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    searchText: null,
    selectedOption: null,
  }),
  computed: {
    availableOptions() {
      return this.options.slice(0, this.maxResults);
    },

    showOptions() {
      return !!(!this.selectedOption && this.searchText);
    },
  },
  watch: {
    value: function(newVal) {
      this.$set(this, 'selectedOption', newVal);
    },
  },
  methods: {
    async clearSelectedOption() {
      this.$set(this, 'selectedOption', null);
      this.updateExternalValue();
      await this.$nextTick();
      this.$refs.searchText.focus();
    },

    selectOption(option) {
      this.$set(this, 'searchText', null);
      this.$set(this, 'selectedOption', option);
      this.updateExternalValue();
    },

    updateExternalValue() {
      this.$emit('input', this.selectedOption);
      this.$emit('change');
    },

    // Events
    searchTextUpdated() {
      this.$emit('search-text-updated', this.searchText);
    },
    // END Events
  },
};
</script>

<style lang="scss" scoped>
@import "@dui-styles/base";

.dui-option-search {
  position: relative;

  &[disabled] {
    opacity: $disabled-opacity;
    pointer-events: none;
  }

  .options-container .option,
  .selected-option {
    img {
      height: $_4em;
      margin-right: $_0-5em;
      vertical-align: middle;
      width: $_4em;
    }
  }

  .selected-option {
    margin: $border-width-base 0;

    .label-sm .button-close {
        margin-left: $_0-5em;
    }
  }

  .options-container {
    background: getColor($white);
    border: $border-width-base solid getColor($grey, fade);
    border-radius: $border-radius-base;
    box-sizing: border-box;
    display: none;
    left: 0;
    overflow: hidden;
    position: absolute;
    top: calc(100% + #{ $_1em });
    width: 100%;
    z-index: $z-index-form-elements;

    &.show-options {
      display: block;
    }

    &.searching {
      padding: $_3em;
      text-align: center;
    }

    .no-results {
      padding: $_1em $_2em;
    }

    .option {
      cursor: pointer;
      display: block;
      padding: $_1em $_4em $_1em $_1-5em;
      position: relative;

      @include ellipsis();

      @include transition((
        background-color
      ));

      &:hover {
        background-color: getColor($grey);
      }
    }
  }
}
</style>
